export default class UserRoles {
  public static Practitioner: string = "Practitioner";
  public static OrgAdmin: string = "OrgAdmin";
  public static PlatformAdmin: string = "PlatformAdmin";
}
